/*
 * @Author: lv 992526373@qq.com
 * @Date: 2022-07-20 10:54:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-17 18:36:21
 * @FilePath: \pythond:\前端\藏文化元素基因库网站\src\components\footer\index.tsx
 * @Description:
 *
 * Copyright (c) 2022 by lv 992526373@qq.com, All Rights Reserved.
 */
import React, { ReactElement } from 'react';
import { Layout } from 'antd';
import './index.less';
import beian from '../../assets/beian/beian.png';

const { Footer } = Layout;

const MyFooter: React.FC = (): ReactElement => (
    <Footer>
        <div className="beianContainer">
            <a href="https://beian.miit.gov.cn">青ICP备2022000463号-1</a>
            <div className="beian">
                <a
                    target="_blank"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=63022102000068"
                    rel="noreferrer"
                >
                    <img src={beian} />
                    <p>青公网安备 63022102000068号</p>
                </a>
            </div>
        </div>

        <div>Copyright &copy;2022 All rights reserved 青海武汉理工大学文化科技融合产业技术研究院 </div>
    </Footer>
);

export default MyFooter;
